import { render, staticRenderFns } from "./ApprovalNeed.vue?vue&type=template&id=4b234320&scoped=true&"
import script from "./ApprovalNeed.vue?vue&type=script&lang=js&"
export * from "./ApprovalNeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b234320",
  null
  
)

export default component.exports